module.exports = __webpack_public_path__ + "static/media/iconfinder_4_4698570.83a89731.png";